export const BackLinkAllCss = {
  textFieldBoxSx: {
    display: { xs: 'grid', sm: 'flex' },
    gap: '20px',
    width: '100%'
  },
  exploreReferringPagesSx: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    color: 'var(--color-primary)'
  },
  searchBtnSx: {
    maxWidth: '159px',
    minWidth: '158px',
    maxHeight: '44px',
    borderRadius: '6px',
    gap: '8px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px'
  },
  enterWebSiteSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px'
  },
  textfieldSubBox: {
    width: '100%'
  },
  paginationBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  getMoreBacklinksBtn: {
    minWidth: '153px',
    maxHeight: '40px',
    gap: '6px',
    paddingTop: '10px',
    paddingRight: '16px',
    paddingBottom: '10px',
    paddingLeft: '16px',
    borderRadius: '6px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  getMoreBacklinksText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  }
};

export const BackLinkInfoCSS = {
  mainBox: {
    width: '100%',
    borderRadius: '12px',
    gap: '20px',
    padding: '20px',
    background: '#F5F6F8',
    marginTop: '32px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    maxWidth: '498px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '12px',
    marginBottom: '20px'
  },
  bgWhite: {
    background: 'var(--color-white)'
  },
  filterBox: {
    minWidth: '155px',
    maxHeight: '40px',
    gap: '8px',
    paddingTop: '10px',
    paddingRight: '16px',
    paddingBottom: '10px',
    paddingLeft: '16px',
    borderRadius: '6px',
    border: '1px solid var(--color-border-muted)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  filterTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: '#6C6D71'
  },
  filterSubBox: {
    display: { xs: 'grid', md: 'flex' },
    alignItems: 'center',
    gap: '12px'
  }
};

export const LocalSeoInfoBoxCss = {
  mainBoxSx: {
    width: '100%',
    borderRadius: '12px',
    padding: '32px',
    boxShadow: '0px 4px 8px -2px #1018281A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage:
      'url("/static/images/icons/local-seo/local-seo-info-seo.png")', // Replace with your actual image path
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  cardSx: {
    borderRadius: '12px',
    padding: '32px',
    boxShadow: '0px 4px 8px -2px #1018281A',
    backgroundColor: 'var(--color-white)'
  },
  mainDesc: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginBottom: '12px',
    maxWidth: '568px'
  },
  subDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginBottom: '24px',
    maxWidth: '428px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  btnBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '12px',
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  learnMoreBtn: {
    padding: '10px 16px 10px 16px',
    borderRadius: '6px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  learnMoreBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  watchYouTubeVideoBtn: {
    padding: '12px 32px 12px 32px',
    borderRadius: '6px'
  },
  watchYouTubeVideoBtnText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-white)'
  },
  footerBoxSx: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '4px'
  },
  dontHaveAccount: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  setItUpNow: {
    color: 'var(--color-success-dark)',
    cursor: 'pointer'
  },
  greenUpIconSx: {
    marginTop: '3px',
    cursor: 'pointer'
  }
};
